document.addEventListener("DOMContentLoaded", function() {

    const quizButton  = document.querySelector('.cs-quiz-button-main');
    const quizOption  = document.querySelectorAll('.cs-option-outer');
    const quizPrev    = document.querySelectorAll('.cs-prev-btn');
    const quizNext    = document.querySelectorAll('.cs-nxt-btn');
    const submitBtn   = document.querySelectorAll('.cs-nxt-btn-submit.cs-submit-btn');
    const submitPrev  = document.querySelectorAll('.cs-prev-btn-submit');
    let resultBox     = document.querySelector(".cs-season-result p");
    let popupClose    = document.querySelectorAll('button.cs-icon-close-button');
    let quizMenu      = document.querySelector('.cs-color-quiz-list');
    let quizSection   = document.querySelector('.sc-quiz-main');
    let SeasonButton  = document.querySelector('.nov-block__text.text-center.position-relative a');
    let SeasonButton2 = document.querySelector('.block-text.text-left.position-relative .btn-normal');
    let SeasonButton3 = document.querySelector('.nova-text-main-btn-btn_UfaY73');
    let SeasonButton4 = document.querySelector('.nova-text-main-btn-btn_QFReta');



    let editionRadios = document.querySelectorAll('input[name="edition"]');
let readyToWearMain = document.querySelectorAll('.ready-to-wear-section-sc');
let bespokeMain     = document.querySelectorAll('.bespoke-section-sc');
let addToCartMain   = document.querySelectorAll('.add-to-cart-main-sc');
let BuyNowBtnMain   = document.querySelectorAll('.buy-now-btn-main-sc');

editionRadios.forEach((radio) => {
  radio.addEventListener("change", function () {
    if (this.value === "bespoke") {
      bespokeMain.forEach(el => el.classList.add('active'));
      readyToWearMain.forEach(el => el.classList.remove('active'));
      addToCartMain.forEach(el => el.classList.add('deactive'));
      BuyNowBtnMain.forEach(el => el.classList.add('deactive'));
    } else {
      bespokeMain.forEach(el => el.classList.remove('active'));
      readyToWearMain.forEach(el => el.classList.add('active'));
      addToCartMain.forEach(el => el.classList.remove('deactive'));
      BuyNowBtnMain.forEach(el => el.classList.remove('deactive'));


    }
  });
});


    let addToCartButton = document.getElementById('AddToCart');
let variantIdMain = document.getElementById('variant_id')?.value;

setTimeout(() => {
  let quickCartButton = document.querySelector('shop-pay-wallet-button');

  if (quickCartButton) {
    quickCartButton.removeAttribute('disabled');

    const innerButton = quickCartButton.shadowRoot
      ? quickCartButton.shadowRoot.querySelector('button')
      : quickCartButton;

    if (innerButton) {
      innerButton.addEventListener('click', function (e) {
        e.preventDefault();
        fetch('/cart/clear.js', { method: 'POST' })
          .then(() => {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantIdMain, quantity: 1 }),
            });
          })
          .then(() => {
            window.location.href = '/checkout';
          })
          .catch((error) => {
            console.error('Error during quick checkout:', error);
          });
      });
    }
  }
}, 2000);

if (addToCartButton) {
  addToCartButton.addEventListener('click', function (e) {
    e.preventDefault();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantIdMain, quantity: 1 }),
    })
      .then((response) => response.json())
      .then(() => {
        window.location.href = '/cart';
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
      });
  });
}



    if(document.querySelector('body').classList.contains('Temp-color-consultation')){
        if (SeasonButton) {
          SeasonButton.addEventListener('click', function(e) {
            e.preventDefault();
            quizSection.classList.remove('hidden', 'popup-close-event')

          });
        }
      }

    if(document.querySelector('body').classList.contains('Temp-color-consultation')){
      if (SeasonButton2) {
        SeasonButton2.addEventListener('click', function(e2) {
          e2.preventDefault();
          quizSection.classList.remove('hidden', 'popup-close-event')

        });
      }
    }

    if(document.querySelector('body').classList.contains('Temp-color-consultation')){
      if (SeasonButton4) {
        SeasonButton4.addEventListener('click', function(e4) {
          e4.preventDefault();
          quizSection.classList.remove('hidden', 'popup-close-event')

        });
      }
    }

    
    if(document.querySelector('body').classList.contains('Temp-color-consultation')){
      if (SeasonButton3) {
        SeasonButton3.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          quizSection.classList.remove('hidden', 'popup-close-event');
        });
      }
    }

    if(quizMenu){
      quizMenu.addEventListener('click',function(e){
        e.preventDefault();
        quizSection.classList.remove('hidden');
      })
    }





  window.addEventListener("scroll", function () {
  let scrollTop = window.scrollY || document.documentElement.scrollTop;
  let windowHeight = window.innerHeight;
  let docHeight = document.documentElement.scrollHeight;

  let scrolledPercent = ((scrollTop + windowHeight) / docHeight) * 100;

  if (scrolledPercent >= 70) {
    if(quizSection){
      quizSection.classList.remove('hidden');
    }
  }
});



if (popupClose) {
  popupClose.forEach(function(element) {
    element.addEventListener('click', function(e) {
      e.preventDefault();
    document.querySelector('.sc-quiz-main').classList.add('hidden', 'popup-close-event');
    });
  });
}




    if(submitPrev){
      submitPrev.forEach(function(element){
        element.addEventListener('click',function(el){
          el.preventDefault();
          resultBox.innerHTML="";
          document.querySelector('.cs-season-result').classList.add('hidden');
          document.querySelector('.cs-last-index').classList.remove('hidden');
          document.querySelector('.cs-email-content-main.cs-quiz-option-cell').classList.add('hidden');
          document.querySelectorAll('.cs-popup-error').forEach(function(el){
            el.classList.add('hidden');
          });
        });
      });
    }



    if (submitBtn) {
  submitBtn.forEach(function (element) {
    element.addEventListener("click", function (el) {
      el.preventDefault();

      const q1 = document.querySelector('input[name="q1"]:checked')?.value;
      const q2 = document.querySelector('input[name="q2"]:checked')?.value;
      const q3 = document.querySelector('input[name="q3"]:checked')?.value;
      const q4 = document.querySelector('input[name="q4"]:checked')?.value;
      const q5 = document.querySelector('input[name="q5"]:checked')?.value;
      const q6 = document.querySelector('input[name="q6"]:checked')?.value;

      let votes = { A: 0, B: 0, C: 0, D: 0 };

      function addVote(answer) {
        if (!answer) return;

        if (["A", "B", "C", "D"].includes(answer)) {
          votes[answer]++;
          return;
        }

        if (
          answer.includes("Peach") ||
          answer.includes("aqua") ||
          answer.includes("sky blue") ||
          answer.includes("Mykonos") ||
          answer.includes("Ibiza")
        ) {
          votes["A"]++;
        } else if (
          answer.includes("Soft pink") ||
          answer.includes("lavender") ||
          answer.includes("grey") ||
          answer.includes("Paris") ||
          answer.includes("London")
        ) {
          votes["B"]++;
        } else if (
          answer.includes("Olive") ||
          answer.includes("terracotta") ||
          answer.includes("deep pink") ||
          answer.includes("Marrakech") ||
          answer.includes("Jaipur")
        ) {
          votes["C"]++;
        } else if (
          answer.includes("Black") ||
          answer.includes("emerald") ||
          answer.includes("neon") ||
          answer.includes("Tokyo") ||
          answer.includes("New York") ||
          answer.includes("St. Moritz")
        ) {
          votes["D"]++;
        }
      }

      [q1, q2, q3, q4, q5, q6].forEach(addVote);


      let maxVotes = Math.max(...Object.values(votes));
      let winners = Object.keys(votes).filter(
        (k) => votes[k] === maxVotes
      );

      let OptionResult = "";
      if (winners.length === 1) {
        if (winners[0] === "A") OptionResult = "Spring";
        if (winners[0] === "B") OptionResult = "Summer";
        if (winners[0] === "C") OptionResult = "Autumn";
        if (winners[0] === "D") OptionResult = "Winter";
      } else {
        OptionResult = winners
          .map((w) =>
            w === "A"
              ? "Spring"
              : w === "B"
              ? "Summer"
              : w === "C"
              ? "Autumn"
              : "Winter"
          )
          .join(" & ");
      }

      let resultBox = document.querySelector(".cs-season-result p");
      if (resultBox) {
        resultBox.innerHTML = `We think you're a ${OptionResult}  — a guide, not a rule.` ;
      }
    });
  });
}



if (submitBtn) {
  submitBtn.forEach(function (element) {
    element.addEventListener("click", function (e) {
      e.preventDefault();

      let klavioEmail = document.getElementById("email_01K64S00FG6FP6AA2CXEA3Q676");
      let klavioResult = document.getElementById("Result_01K64S00FNT8613Z1V6937Z51Q");
      let klavioSubmit = document.querySelector("button.needsclick");
      let collectionResult = document.querySelector(".cs-collection-result");

      let emailInput = document.querySelector(".cs-form-input");
      let customerEmail = emailInput.value.trim();

      if (!customerEmail) {
        document.querySelector(".cs-popup-error-submit").classList.remove("hidden");
        emailInput.focus();
        return;
      }

      let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(customerEmail)) {
        document.querySelector(".cs-popup-error-submit").classList.remove("hidden");
        emailInput.focus();
        return;
      }
      document.querySelector(".cs-popup-error-submit").classList.add("hidden");

      const answers = {
        Q1: document.querySelector('input[name="q1"]:checked')?.value || "Not sure",
        Q2: document.querySelector('input[name="q2"]:checked')?.value || "Not sure",
        Q3: document.querySelector('input[name="q3"]:checked')?.value || "Not sure",
        Q4: document.querySelector('input[name="q4"]:checked')?.value || "Not sure",
        Q5: document.querySelector('input[name="q5"]:checked')?.value || "Not sure",
        Q6: document.querySelector('input[name="q6"]:checked')?.value || "Not sure"
      };

      const result = evaluateSeasonV51(answers);
      const season = result.season;

      const payload = {
        quiz_version: "v5.1",
        answers,
        result,
        timestamp: new Date().toISOString()
      };

      document.querySelector(".email-text-para").classList.add("hidden");
      document.querySelector(".cs-form-input").classList.add("hidden");

      let OptionResult = `We think you're a ${season} — a guide, not a rule.`;
      document.querySelector(".cs-season-result p").innerHTML = OptionResult;
      document.querySelector(".cs-season-result").classList.remove("hidden");
      emailInput.value = "";

      if (klavioEmail) klavioEmail.setAttribute("value", customerEmail);
      if (klavioResult) klavioResult.setAttribute("value", season);

      if (klavioEmail) {
        klavioEmail.dispatchEvent(new Event("input", { bubbles: true }));
        klavioEmail.dispatchEvent(new Event("change", { bubbles: true }));
      }
      if (klavioResult) {
        klavioResult.dispatchEvent(new Event("input", { bubbles: true }));
        klavioResult.dispatchEvent(new Event("change", { bubbles: true }));
      }

      if (klavioSubmit) {
        setTimeout(() => {
          klavioSubmit.click();
          setTimeout(() => {
            klavioEmail?.setAttribute("value", "");
            klavioResult?.setAttribute("value", "");
          }, 2000);
        }, 2000);
      }

      if (season === "Spring") collectionResult.setAttribute("href", "/collections/spring-colours");
      else if (season === "Summer") collectionResult.setAttribute("href", "/collections/summer-colours");
      else if (season === "Autumn") collectionResult.setAttribute("href", "/collections/autumn-colours");
      else if (season === "Winter") collectionResult.setAttribute("href", "/collections/winter-collection");

      document.querySelector(".cs-email-content-main .cs-quiz-pre-nxt-button")?.classList.add("hidden");
      document.querySelector(".cs-email-content-main").classList.add("hidden")
    });
  });
}

function evaluateSeasonV51(answers) {
  const { Q1, Q2, Q3, Q4, Q5, Q6 } = answers;
  const score = { Warm: 0, Cool: 0, Soft: 0, Clear: 0, Light: 0, Deep: 0 };

  if (Q1 === "Gold") score.Warm += 0.5;
  else if (Q1 === "Silver") score.Cool += 0.5;

  if (["Blonde", "Light Brown", "Grey", "White"].includes(Q2)) score.Light += 1;
  if (["Brown (cool)", "Black"].includes(Q2)) { score.Deep += 1; score.Cool += 0.5; }
  if (["Brown (warm / reddish highlights)", "Red", "Auburn"].includes(Q2)) { score.Deep += 1; score.Warm += 1; }

  if (Q3 === "Blue - Soft") { score.Cool += 1; score.Soft += 1; }
  else if (Q3 === "Blue - Vivid") { score.Cool += 1; score.Clear += 1; }
  else if (Q3 === "Green / Hazel / Olive") { score.Warm += 1; }
  else if (Q3.startsWith("Brown")) { score.Deep += 1; score.Warm += 0.5; score.Cool += 0.5; }
  else if (Q3 === "Grey") { score.Cool += 1; score.Soft += 0.5; }

  if (Q4 === "Burn easily") { score.Cool += 0.5; score.Soft += 0.5; }
  else if (Q4 === "Tan gradually after burning") { score.Warm += 0.5; score.Soft += 0.5; }
  else if (Q4 === "Tan easily") { score.Clear += 0.75; }

  if (Q5 === "Ivory / Cream (Warm)") score.Warm += 1;
  else if (Q5 === "Pure White (Cool)") score.Cool += 1;

  if (Q6 === "They energise me (Clear)") score.Clear += 1;
  else if (Q6 === "They overpower me (Soft)") score.Soft += 1;

  const warmth = score.Warm >= score.Cool ? "Warm" : "Cool";
  const chroma = score.Soft >= score.Clear ? "Soft" : "Clear";
  let season = "";
  if (warmth === "Warm" && chroma === "Soft") season = "Autumn";
  else if (warmth === "Warm" && chroma === "Clear") season = "Spring";
  else if (warmth === "Cool" && chroma === "Soft") season = "Summer";
  else season = "Winter";

  const quadrantScores = {
    Spring: (score.Warm + score.Clear + score.Light),
    Summer: (score.Cool + score.Clear + score.Light),
    Autumn: (score.Warm + score.Soft + score.Deep),
    Winter: (score.Cool + score.Clear + score.Deep)
  };
  const ordered = Object.entries(quadrantScores).sort((a, b) => b[1] - a[1]);
  const top = ordered[0][1], runner = ordered[1][1];
  const confidence = top - runner >= 1 ? "High" : top - runner >= 0.5 ? "Medium" : "Close";

  return { season, confidence, dims: score, runnerUp: ordered[1][0] };
}

    if(quizButton){
        quizButton.addEventListener('click',function(e) {
            e.preventDefault();
            document.querySelector('.cs-quiz-content').classList.remove('hidden');
            document.querySelector('.cs-quiz-heading').classList.add('hidden');
            document.querySelector('.cs-quiz-container').classList.add('popup-active');
            document.querySelector('.sc-quiz-main').classList.add('popup-active-2');
        })
    }

    if (quizOption) {
      quizOption.forEach(function(element) {
        element.addEventListener('click', function() {
        let grandParent = element.closest('.cs-quiz-option-cell');
        let quizInput = element.querySelector('input[type="radio"]');
        if (quizInput) {
          quizInput.checked = true; 
        }
        let parent = element.closest('.options-cell-top');
        if (parent) {
          let siblings = parent.querySelectorAll('.cs-option-outer');
          siblings.forEach(function(el) {
            el.classList.remove('checked');
          });

          element.closest('.cs-option-outer').classList.add('checked');
        }

        let quizQuestion = parent ? parent.getAttribute('question-data') : null;
        let quizAnswer = quizInput ? quizInput.value : null;
  
        let quizCell = element.closest('.cs-quiz-option-cell');
        let popup = quizCell ? quizCell.querySelector('.cs-popup-error') : null;
        if (popup) {
          popup.classList.add('hidden');
        }

      if (grandParent && grandParent.classList.contains('cs-last-index')) {
        document.querySelector('.cs-email-content-main.cs-quiz-option-cell').classList.remove('hidden');
        document.querySelector('.cs-last-index').classList.add('hidden')
      } else {
        let nxtBtnTrigger = quizCell ? quizCell.querySelector('.cs-nxt-btn') : null;
        if (nxtBtnTrigger) {
          nxtBtnTrigger.click();
        }
      }

      });
    });
  }

      if (quizPrev.length > 0) {
        quizPrev.forEach(function(element) {
          element.addEventListener('click', function() {
            document.querySelector('.cs-season-result').classList.add('hidden')
            let parent = element.closest('.cs-quiz-option-cell');
            let currentIndex = parent ? parseInt(parent.getAttribute('data-index')) : null;

            let wrapper = element.closest('.cs-quiz-pre-nxt-button');
            let sibling = wrapper ? wrapper.previousElementSibling : null;
            let csOption = sibling ? sibling.querySelector('.cs-option-outer') : null;

            if (parent && parent.classList.contains('cs-first-index')) {
            } else {
              if (currentIndex !== null) {
                parent.classList.add('hidden');
                parent.classList.remove('selected');

                let prevIndex = currentIndex - 1;
                let prevElement = document.querySelector('.cs-quiz-option-cell[data-index="' + prevIndex + '"]');

                if (prevElement) {
                  prevElement.classList.add('selected');
                  prevElement.classList.remove('hidden');
                }
              }
            }
          });
        });
      }

if (quizNext.length > 0) {
  quizNext.forEach(function(element) {
    element.addEventListener('click', function() {
      let parent = element.closest('.cs-quiz-option-cell');
      let currentIndex = parent ? parseInt(parent.getAttribute('data-index')) : null;

        document.querySelector('.email-text-para').classList.remove('hidden');

      let errorPopup = parent.querySelector('.cs-popup-error');

      if (parent.classList.contains('cs-last-index')) {
      }
      else {
        let puzzleSelectTrue = parent.querySelectorAll('.cs-option-outer');
        puzzleSelectTrue.forEach(function(elm) {
          if (elm.classList.contains('checked')) {
            errorPopup.classList.add('hidden');
            let quizQuestion2 = parent.getAttribute('question-attr');

            let checkedInput2 = parent.querySelector('.cs-option-outer input:checked');
            let quizAnswer2 = checkedInput2 ? checkedInput2.value : null;

            if (currentIndex !== null) {
              parent.classList.add('hidden');
              parent.classList.remove('selected');
              let nextIndex = currentIndex + 1;
              let nextElement = document.querySelector('.cs-quiz-option-cell[data-index="' + nextIndex + '"]');

              if (nextElement) {
                nextElement.classList.add('selected');
                nextElement.classList.remove('hidden');
              }
            }

          } else {
            errorPopup.classList.remove('hidden');
          }
        });
      }

    });
  });
}


});

/* ============================================================
   ADDED BY CLAUDE 2 JULY 2026 -- BACK BUTTON on product pages
   ============================================================ */
;(function () {
  var attempts = 0;
  var maxAttempts = 40;

  function addBackButton() {
    if (document.querySelector('.cos-back-button')) return true;

    var container = document.querySelector('#proFeaturedImageZoom');
    if (!container) return false;

    var wrapper = container.closest('.product-single__photos') || container.parentElement;
    if (!wrapper) return false;
    if (getComputedStyle(wrapper).position === 'static') {
      wrapper.style.position = 'relative';
    }

    var sameSiteReferrer = document.referrer && document.referrer.indexOf(window.location.origin) === 0;
    var fallbackUrl = '/collections/all-bracelets';

    var btn = document.createElement('a');
    btn.className = 'cos-back-button';
    btn.setAttribute('aria-label', 'Back');
    btn.href = sameSiteReferrer ? document.referrer : fallbackUrl;
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 12H5M12 19l-7-7 7-7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    if (sameSiteReferrer) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        history.back();
      });
    }

    wrapper.insertBefore(btn, wrapper.firstChild);
    return true;
  }

  function tryAdd() {
    if (addBackButton()) return;
    attempts++;
    if (attempts < maxAttempts) {
      setTimeout(tryAdd, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryAdd);
  } else {
    tryAdd();
  }
  window.addEventListener('load', tryAdd);
})();

/* ============================================================
   ADDED BY CLAUDE 2 JULY 2026 -- CUSTOM KLARNA MESSAGE
   ============================================================ */
;(function () {
  var attempts = 0;
  var maxAttempts = 40;

  function poundsFormat(pounds) {
    return '£' + pounds.toFixed(2);
  }

  function getProductPrice() {
    var selectors = ['.product-single__price', '.price__regular .price-item--regular', '.price-item--sale', '.product__price'];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        var m = (el.textContent || '').match(/£\s*([\d.,]+)/);
        if (m) {
          var num = parseFloat(m[1].replace(/,/g, ''));
          if (!isNaN(num) && num > 0) return num;
        }
      }
    }
    return null;
  }

  function buildKlarnaMessage() {
    if (document.querySelector('.cos-klarna-message')) return true;

    var priceEl = document.querySelector('.product-single__price');
    if (!priceEl) return false;

    var pounds = getProductPrice();
    if (!pounds) return false;

    var perInstalment = pounds / 3;

    var msg = document.createElement('p');
    msg.className = 'cos-klarna-message';
    msg.innerHTML = 'Or 3 instalments of <strong>' + poundsFormat(perInstalment) + '</strong> with <span class="cos-klarna-badge">Klarna</span> at checkout.';

    priceEl.parentNode.insertBefore(msg, priceEl.nextSibling);
    return true;
  }

  function tryBuild() {
    if (buildKlarnaMessage()) return;
    attempts++;
    if (attempts < maxAttempts) {
      setTimeout(tryBuild, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryBuild);
  } else {
    tryBuild();
  }
})();

/* ============================================================
   ADDED BY CLAUDE 2 JULY 2026 -- MENU SCROLL HINT
   Detects any scrollable menu panel (mobile menu, Shop
   dropdown, etc.) and adds a soft fade + animated chevron at
   its bottom edge to show there's more content below. The hint
   fades away once the user reaches the bottom, and reappears
   if they scroll back up. Fully generic -- no hardcoded menu
   structure, so it works wherever menus overflow.
   ============================================================ */
;(function () {
  var CANDIDATES = '.mm-panels .mm-panel, .mm-panel, .header__submenu, .sub-menu, .submenu, .dropdown-menu, .mega-menu, [class*="submenu"], [class*="mega"], nav ul';
  var CHEVRON = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function isScrollable(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var rect = el.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    var style = getComputedStyle(el);
    var oy = style.overflowY;
    if (oy !== 'auto' && oy !== 'scroll') return false;
    return el.scrollHeight - el.clientHeight > 40;
  }

  function updateHint(el, hint) {
    var atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 24;
    if (atBottom) {
      hint.classList.add('cos-hidden');
    } else {
      hint.classList.remove('cos-hidden');
    }
  }

  function attachHint(el) {
    if (el.dataset.cosHint) return;
    el.dataset.cosHint = '1';

    var hint = document.createElement('div');
    hint.className = 'cos-scroll-hint';
    hint.innerHTML = CHEVRON;
    el.appendChild(hint);

    updateHint(el, hint);
    el.addEventListener('scroll', function () {
      updateHint(el, hint);
    }, { passive: true });
  }

  function scan() {
    document.querySelectorAll(CANDIDATES).forEach(function (el) {
      if (el.dataset.cosHint) {
        var hint = el.querySelector(':scope > .cos-scroll-hint');
        if (hint) {
          if (isScrollable(el)) {
            updateHint(el, hint);
          } else {
            hint.classList.add('cos-hidden');
          }
        }
        return;
      }
      if (isScrollable(el)) {
        attachHint(el);
      }
    });
  }

  function init() {
    scan();
    // Menus open on click/tap -- re-scan shortly after any interaction
    document.addEventListener('click', function () {
      setTimeout(scan, 350);
      setTimeout(scan, 900);
    }, { passive: true });
    window.addEventListener('resize', function () {
      setTimeout(scan, 300);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', scan);
})();
